import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="companies"
export default class extends Controller {
  static targets = ["newCompanyPanel", "companyNameField", "websiteField", "businessEmailField", "businessPhoneField", "businessAddressField", "businessCityField", "businessStateField", "businessZipField", "companyModifiedField"]

  connect() {
  }

  loadCompanyData(event) {
    const companyId = event.currentTarget.value
    if (!companyId){
      this.companyNameFieldTarget.value = ""
      this.websiteFieldTarget.value = ""
      this.businessEmailFieldTarget.value = ""
      this.businessPhoneFieldTarget.value = ""
      this.businessAddressFieldTarget.value = ""
      this.businessCityFieldTarget.value = ""
      this.businessStateFieldTarget.value = ""
      this.businessZipFieldTarget.value = ""
      this.companyModifiedFieldTarget.value = "0"
      this.newCompanyPanelTarget.style.display = "block"
    } else {

      fetch(`/companies/get_company_data?id=${companyId}`, {
        headers: { Accept: "application/json" }
      })
        .then(r => r.json())
        .then(data => {
          if (data.status !== 200) return
          const c = data.company
          this.companyNameFieldTarget.value = c.company_name || ""
          this.websiteFieldTarget.value = c.website || ""
          this.businessEmailFieldTarget.value = c.business_email || ""
          this.businessPhoneFieldTarget.value = c.business_phone || ""
          this.businessAddressFieldTarget.value = c.address || ""
          this.businessCityFieldTarget.value = c.city || ""
          this.businessStateFieldTarget.value = c.state || ""
          this.businessZipFieldTarget.value = c.zip_code || ""
          this.companyModifiedFieldTarget.value = "0"
          this.newCompanyPanelTarget.style.display = "block"
        })
    }
  }

  markCompanyModified() {
    this.companyModifiedFieldTarget.value = "1"
  }

  toggleNewCompanyPanel(event) {
    const panel = this.newCompanyPanelTarget
    panel.style.display = event.currentTarget.value === "new" || event.currentTarget.value === '' ? "block" : "none"
  }

  /*
   * Dynamically loads sub-categories when the user selects a parent business category.
   * Business categories have a two-level hierarchy: parent categories (e.g., "Financial Services")
   * and sub-categories (e.g., "Accounting", "Insurance"). The sub-category dropdown is empty
   * until a parent is selected.
   *
   * We only fire the AJAX call when item.value > 0, which skips the "-- Select Category --"
   * placeholder option (value=0). The response is a JSON array of { id, name } objects that
   * we loop over using Object.keys() to build the <option> elements.
   * If there are no sub-categories for the selected parent, we clear the dropdown rather
   * than leaving stale options from a previous selection visible.
   */
  getSubCategory(e) {
    var item = e.currentTarget
    if(item.value > 0) {
      $.ajax({
        type: "GET",
        url: "/business_categories/get_sub_categories",
        data: {
          id: item.value
        },
        success: function(data) {
          if(data.status == 200) {
            var items = JSON.parse(data.options)

            if(items.length > 0){
              var options = "<option>-- Select Sub Category (optional) --</option>"

              Object.keys(items).forEach(function(key){
                options += "<option value='" + items[key]['id'] + "'>" + items[key]['name'] + "</option>";
              })
            } else {
              var options = ""
            }

            document.getElementById('membership_business_sub_category_id').innerHTML = options
          } else {
            alert("Sub Categories did not load. Please try again.")
          }
        }
      })
    }
  }
}
